import { useMutation } from '@tanstack/react-query';

import { updateBusinessHours } from '../api/businessHoursApi';
import { useBusinessSettingsStore } from '../store/businessSettingsStore';
import type { ApiDayCode, DayOfWeek, HoursScheduleEntry, ScheduleData, UpdateHoursRequest } from '../types';

const DAY_CODE_MAP: Record<DayOfWeek, ApiDayCode> = {
  monday: 'MON',
  tuesday: 'TUE',
  wednesday: 'WED',
  thursday: 'THU',
  friday: 'FRI',
  saturday: 'SAT',
  sunday: 'SUN',
};

export function buildHoursRequest(schedule: ScheduleData): UpdateHoursRequest {
  const entries: HoursScheduleEntry[] = (Object.keys(DAY_CODE_MAP) as DayOfWeek[]).map((day) => {
    const s = schedule[day];
    return s.open
      ? { day: DAY_CODE_MAP[day], isClosed: false, startTime: s.from, endTime: s.to }
      : { day: DAY_CODE_MAP[day], isClosed: true, startTime: null, endTime: null };
  });

  return {
    timezone: import.meta.env.VITE_TIMEZONE,
    schedule: entries,
  };
}

export function useBusinessHours() {
  const accountId = useBusinessSettingsStore((s) => s.account?.accountId);

  const mutation = useMutation({
    mutationFn: (request: UpdateHoursRequest) => {
      if (!accountId) throw new Error('Account ID not found');
      return updateBusinessHours(accountId, request);
    },
  });

  return {
    submitHours: mutation.mutate,
    isPending: mutation.isPending,
  };
}
